import { BusinessUnits } from '@ratehub/base-ui';


// Defines what BUs are supported in the BlogSpotlight component & block.
// We want to be able to control what BUs are available in this component
// as needed, as opposed to just referencing BusinessUnits.js and including
// all of them.
export default [
    BusinessUnits.MORTGAGES,
    BusinessUnits.CREDIT_CARDS,
    BusinessUnits.BANKING,
    BusinessUnits.INVESTING,
    BusinessUnits.INSURANCE,
    BusinessUnits.CRYPTO,
    BusinessUnits.ALL,
];
